import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Lightbulb, TrendingUp, FileText, Calendar } from "lucide-react";

const tips = [
  {
    icon: Lightbulb,
    title: "💰 Smart Money Move",
    tip: "Stay organized all year long! Keep your receipts sorted by category to save hours during tax season and unlock every deduction you're entitled to.",
  },
  {
    icon: TrendingUp,
    title: "📊 Pro Tax Strategy",
    tip: "Self-employed? That home office can save you big! Deduct expenses like rent, utilities, and internet when you have a dedicated workspace for your business.",
  },
  {
    icon: FileText,
    title: "🎯 Expert Advice",
    tip: "The early bird gets the refund! File in January or February to get your money back faster, beat the rush, and protect yourself from identity theft.",
  },
  {
    icon: Calendar,
    title: "💡 Insider Tax Tip",
    tip: "Running your own business? Make quarterly estimated tax payments to spread the cost throughout the year and avoid a shocking bill on April 15th.",
  },
];

export const TaxTipCard = () => {
  const [currentTip, setCurrentTip] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTip((prev) => (prev + 1) % tips.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  const CurrentIcon = tips[currentTip].icon;

  return (
    <Card className="p-8 bg-gradient-to-br from-accent/15 via-secondary/10 to-primary/10 border-2 border-accent/30 shadow-xl relative overflow-hidden animate-fade-in hover:shadow-2xl transition-all duration-500 group">
      <div className="absolute top-0 right-0 w-40 h-40 bg-accent/10 rounded-full blur-3xl group-hover:scale-150 transition-transform duration-700"></div>
      <div className="absolute bottom-0 left-0 w-32 h-32 bg-secondary/10 rounded-full blur-2xl"></div>
      
      <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-accent/20 to-transparent rounded-bl-full"></div>
      
      <div className="relative z-10">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 p-4 bg-gradient-to-br from-accent/30 to-secondary/20 rounded-2xl shadow-lg animate-pulse group-hover:scale-110 transition-transform duration-300">
            <CurrentIcon className="h-7 w-7 text-accent" />
          </div>
          
          <div className="flex-1">
            <div className="mb-3">
              <span className="inline-block px-3 py-1 bg-gradient-to-r from-accent/20 to-secondary/20 rounded-full text-xs font-semibold text-accent border border-accent/20 mb-2">
                TAX SEASON 2025
              </span>
              <h3 className="font-quicksand font-bold text-2xl bg-gradient-to-r from-accent via-secondary to-primary bg-clip-text text-transparent">
                {tips[currentTip].title}
              </h3>
            </div>
            
            <p className="text-foreground/90 text-base leading-relaxed">
              {tips[currentTip].tip}
            </p>
            
            <div className="flex gap-2 mt-4">
              {tips.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTip(index)}
                  className={`h-2 rounded-full transition-all duration-300 ${
                    index === currentTip 
                      ? 'w-8 bg-gradient-to-r from-accent to-secondary' 
                      : 'w-2 bg-muted-foreground/30 hover:bg-muted-foreground/50'
                  }`}
                  aria-label={`View tip ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
